function newInternalCallback() {
	return function internalCallback(callback, optionalKeyCode, event) {
		if(event.keyCode === optionalKeyCode)
			callback(event);
	}
}

module.exports = newInternalCallback;